import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Tag, ShoppingBag } from 'lucide-react';

export default function Offers() {
    const [offers, setOffers] = useState([]);
    const [malls, setMalls] = useState([]);
    const [mall, setMall] = useState('');

    useEffect(() => {
        api.get('/offers').then(({ data }) => setOffers(data));
        api.get('/malls').then(({ data }) => setMalls(data));
    }, []);

    const filtered = mall ? offers.filter((o) => o.mall_ids.includes(mall)) : offers;

    return (
        <div data-testid="offers-page" className="pt-16">
            <section className="max-w-7xl mx-auto px-6 md:px-12 pt-12 pb-12">
                <div className="overline mb-6">Live Offers</div>
                <h1 className="font-serif text-6xl md:text-7xl text-navy leading-[1.02] tracking-tight max-w-4xl">
                    Edits that <span className="italic text-gold">reward you.</span>
                </h1>
            </section>

            <section className="border-y border-border-subtle bg-cream sticky top-20 z-20">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-wrap items-center gap-4">
                    <select className="input-box max-w-[240px]" value={mall} onChange={(e) => setMall(e.target.value)} data-testid="offers-mall-filter">
                        <option value="">All Malls</option>
                        {malls.map((m) => <option key={m.id} value={m.id}>{m.short_name}</option>)}
                    </select>
                    <div className="text-xs uppercase tracking-widest text-text-tertiary">{filtered.length} offers</div>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="offers-grid">
                {filtered.map((o) => (
                    <div id={o.id} key={o.id} className="card-luxury overflow-hidden img-zoom" data-testid={`offer-card-${o.id}`}>
                        <div className="aspect-[5/3] overflow-hidden relative">
                            <img src={o.image_url} alt="" className="w-full h-full object-cover" />
                            {o.is_featured && <div className="absolute top-4 left-4 bg-gold text-white text-[10px] tracking-widest uppercase font-semibold px-3 py-1">Featured</div>}
                            {!o.tier_eligibility.includes('silver') && <div className="absolute top-4 right-4 bg-navy text-white text-[10px] tracking-widest uppercase font-semibold px-3 py-1">{o.tier_eligibility[o.tier_eligibility.length - 1]} only</div>}
                        </div>
                        <div className="p-7">
                            <div className="overline text-gold mb-3">{o.brand_name}</div>
                            <h3 className="font-serif text-2xl text-navy leading-snug mb-3">{o.title}</h3>
                            <p className="text-sm text-text-secondary leading-relaxed mb-5 line-clamp-3">{o.description}</p>
                            {o.coupon_code && (
                                <div className="flex items-center justify-between bg-cream border border-dashed border-gold px-4 py-3 mb-5">
                                    <div className="text-xs uppercase tracking-widest text-text-tertiary">Use code</div>
                                    <div className="font-mono text-sm text-navy font-semibold">{o.coupon_code}</div>
                                </div>
                            )}
                            <div className="flex items-center justify-between text-xs text-text-tertiary uppercase tracking-widest">
                                <span>Valid till {new Date(o.end_date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}</span>
                                {o.min_spend > 0 && <span>Min ₹{o.min_spend}</span>}
                            </div>
                        </div>
                    </div>
                ))}
            </section>
        </div>
    );
}
